export default "__VITE_ASSET__BAd5ebzf__"